import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Layout from "../layout/layout";
import Button from "react-bootstrap/Button";
import GemologicalCharacteristics from "./gemologicalCharacteristics";
import DiamondRare from "./diamondrarity";
import { rarityInstance } from "../../config/axios";
import { getlocalStorage } from "../../utils/getlocalStorage";
import Loader from "../loader/loader";
import PdfArgyleReportTemplate from "./argylePdfReport";
import FcrfContext from "../../Context";
import { serverPath } from "../../config/key";
import "./argyleReport.css";
import { Spinner } from "react-bootstrap";
import {
  SaveIcons,
  HistoryIcons,
  SettingsIcons,

} from "../verticalDropdown/svgData";
import VerticalDropdown from "../verticalDropdown/verticalDropdown";
import Loading from "../Animation/Loading";

const ArgyleReport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const ref = React.createRef();
  const [loading, setLoading] = useState(true);

  const [reportData, setreportData] = useState({});
  const setContext = useContext(FcrfContext);
  const {setSavedNotification } =
    setContext;

  const [reportId, setReportId] = useState({ Id: "", postId: "" });
  const [copied, setCopied] = useState(false);
  const [urlValue, setUrlValue] = useState(null);
  const [isPdf, ] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState("")


  const [isActive,setisActive ] = useState(false);


  useEffect(() => {
    const { action } = location?.state ?? {};
 
    if (action !== "Create") {
      getReportById();
    } else {
      const { id, report } = location?.state ?? {};
      setApiData(id, report);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setApiData = async (id, report) => {
    const { postId } = report;
    const obj = {
      Id: id,
      postId: postId,
    };
    setReportId(obj);
    handleShare(obj);
 
    setreportData(report);
    setLoading(false);
  };

  const handleCreateNewReport = () => {
    window.history.pushState("1", null, "/argyle");
    setContext.setSetps(1);
    navigate("/", {
      state: {
        showArgyle: false,
        tab: "tab2",
      },
    });
  };

  let GraphTextColor = "";

  const color = () => {
    switch (reportData?.data?.color) {
      case "Yellow":
        return "#ffda1a";
      case "Greenish Yellow":
        GraphTextColor = "#333";
        return "#c1e51a";
      case "Orange Yellow":
        return "#ffa330";
      case "Pink":
        return "#f563c0";
      case "Orangy Pink":
        return "#dc7979";
      case "Purplish Pink":
        GraphTextColor = "#333";
        return "#cf2985";
      case "Pinkish Purple":
        return "#a07aa0";
      case "Brownish Pink":
        GraphTextColor = "#333";
        return "#de7394";
      case "Brown Pink":
        GraphTextColor = "#333";
        return "#bc5b78";
      case "Blue":
        return "#4380c5";
      case "Gray Blue":
        return "#97bbe0";
      case "Green Blue":
        GraphTextColor = "#333";
        return "#55887e";
      case "Grayish Blue":
        GraphTextColor = "#333";
        return "#8faac5";
      case "Orange":
        GraphTextColor = "#333";
        return "#ff7c31";
      case "Yellow Orange":
        GraphTextColor = "#333";
        return "#fa9922";
      case "Yellowish Orange":
        GraphTextColor = "#333";
        return "#ff8630";
      case "Brown Orange":
        return "#d67f4a";
      case "Green":
        return "#547055";
      case "Yellow Green":
        GraphTextColor = "#333";
        return "#57ee1a";
      case "Blueish Green":
        GraphTextColor = "#333";
        return "#326b72";
      case "Red":
        GraphTextColor = "#333";
        return "#ec394d";
      case "Purplish Red":
        return "#ec3968";
      case "Brownish Red":
        return "#A52A2A";
      case "Gray":
        GraphTextColor = "#333";
        return "#8f8f8f";
      case "Blue Gray":
        GraphTextColor = "#333";
        return "#8fa3b1";
      case "Purple":
        return "#8c87aa";
      case "Bluish Green":
        return "#6db9a4";
      case "Purple Pink":
        return "#cf29ad";
      case "Brownish Orangy Pink":
        return "#dc7979";
      case "Pink Purple":
        return "#9c4c89";
      case "Gray Violet":
        return "#5a576b";
      case "Grayish Bluish Violet":
        return "#887788";
      case "Grayish Violetish Blue":
        return "#476b8e";
      case "Violet Gray":
        return "#656371";
      case "Violetish Gray":
        return "#656371";
      case "Grayish Violet":
        return "#5a576b";

      default:
        GraphTextColor = "#1B2653";
    }
  };

  const getReportById = async () => {
    setLoading(true);
    try {
      const { id } = location?.state;
      const argyleID = id?.replace("#", "");
      const response = await rarityInstance().get(
        `report/getargylereport?Id=${argyleID}`
      );
      const { status, getReport ,Qrurl } = response?.data;
      const { _id, report } = getReport || {};

      if (status === 200) {
        const obj = {
          Id: _id,
          postId: id,
        };
        setReportId(obj);
        handleShare(obj);
        setQrCodeUrl(Qrurl)
        
        setreportData(report);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };
  const handleDownLoadReport = async () => {
    window.open(reportData.extraritypdfUrl);


    const copyfilterdata = { ...reportData };
    const { is_free, is_subscription, is_role, service } = getlocalStorage();
    copyfilterdata.free = is_free;
    copyfilterdata.subscription = is_subscription || "not active";
    copyfilterdata.role = is_role;
    copyfilterdata.type = "Argyle Export";
    copyfilterdata.service = service;
    copyfilterdata.pdfUrl = service;
    const response = await rarityInstance().post(
      "report/downLoad-argyle-report",
      copyfilterdata
    );
    if (response?.data?.url) {
      copyfilterdata.pdfUrl = response?.data?.url;
    }
    // console.log("response>>>", response);
   

    await rarityInstance().post("report/argyleWebhook", copyfilterdata);
  };
 

  const handleShare = async (obj) => {
    const shareLink = `${serverPath}/share-argyle-report/${obj?.Id}`;
    setUrlValue(shareLink);
  };
  const handleCopy = async () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1500);
    try {
      await rarityInstance().post("report/copy-share-link/Argyle", {
        reportId: reportId.postId,
        shareLink: urlValue,
      });
    } catch (error) {
      console.error("error in copy link===", error);
    }
  };

  const handleSaveReport = async () => {

    setisActive(true)
    const response = await rarityInstance().post("report/saveArgyleReport",{
      reportId,
      recordName:reportData
      ?`${reportData?.data?.saturation} ${reportData?.data?.color} ${reportData?.data?.weight}ct`:"",
    });
    if(response){
    const copyfilterdata = {...response.data.report?.report };
    const { is_free, is_subscription, is_role, service } = getlocalStorage();
    copyfilterdata.free = is_free;
    copyfilterdata.subscription = is_subscription || "not active";
    copyfilterdata.role = is_role;
    copyfilterdata.type = "Argyle saved";
    copyfilterdata.service = service;

    setSavedNotification(true)
    setisActive(false)
    setTimeout(() => {
      setSavedNotification(false);
      navigate("/argyle-save-history")
    }, 1000);
    await rarityInstance().post("report/argyleWebhook", copyfilterdata);
  }

    };

  const dropdownItems = [
  
    {
      icon: HistoryIcons,
      route: "/saved-argyle-report?argyle-report",
      label: "Search History",
    },
    {
      icon: SaveIcons,
      route: "/argyle-save-history",
      label: "Saved Reports",
      // sharefun: handleSaveReport,
    },
    { icon: SettingsIcons, route: `/settings`, label: "Report Settings" },
  ];

  return (
    <>
      <Layout header={"argyle-header"} className={"d-block"}>
        {loading && <Loader type={"progress"} />}
        <div className="argyle-report-page rarity-report-page argyle-report-update-page">
          <div className="rarity-report-head"></div>
        
          <div className="rarity-report-content">
            <div className="container  ">
              <div className="rarity-tool">
                <div className="rarity-header-section grade-desktop-view">
                  <div className="rarity-header-right">
                    <div className="report-action-btn">
                      <Button
                        className="outline-btn"
                        onClick={() => handleCreateNewReport()}
                      >
                        <span><PlusIcon />
                        New
                        </span>
                      </Button>
                      {isPdf ? <Loading text="Loading" /> :
                      <Button
                        className="outline-btn pdf-btn"
                        onClick={() => handleDownLoadReport(reportData?.pdfurl)}
                      >
                        {isPdf ? (
                          <Spinner animation="border" />
                        ) : (
                          <>
                            {" "}
                            <span><DownloadIcon />
                            PDF</span>
                          </>
                        )}
                      </Button>
                      }
                     {isActive?<Loading text={"Saving"}/>:
                      <Button
                        disabled={isActive}
                        className="outline-btn"
                        onClick={() => handleSaveReport()}
                      >
                        <span>
                        <SaveIcons />

                        {isActive ? <Spinner animation="border" /> : "Save"}</span>
                      </Button>
                      }
                     <div className="copy-btn-wrapper">
                      {urlValue && (
                        <CopyToClipboard
                          text={urlValue}
                          onCopy={(e) => handleCopy(e)}
                        >
                          <Button className="outline-btn">
                           <span> <ExportIcon /></span>
                          </Button>
                        </CopyToClipboard>
                      )}

                      <span
                        className={`copied-tooltip ${copied ? "show" : ""}`}
                      >
                        Copied
                      </span>
                    </div>
                    </div>
                   
                    <VerticalDropdown dropdownItems={dropdownItems} />
                  </div>
                </div>
                <div className="rarity-header-section grade-mob-view">
                  <div className="rarity-header-right">
                    <div className="report-action-btn">
                      <Button
                        className="outline-btn"
                        onClick={() => handleCreateNewReport()}
                      >
                        <PlusIcon />
                      </Button>
                      {isPdf ? <Loading text="Loading" type="mobile"/> :
                      <Button
                        className="outline-btn pdf-btn"
                        onClick={() => handleDownLoadReport(reportData?.pdfurl)}
                      >
                        {isPdf ? (
                          <Spinner animation="border" />
                        ) : (
                          <>
                            {" "}
                            <DownloadIcon />
                          </>
                        )}
                      </Button>
                      }
                      {isActive ? <Loading text="Saving" type="mobile"/> :
                      <Button
                        disabled={isActive}
                        className="outline-btn"
                        onClick={() => handleSaveReport()}
                      >
                        {isActive ? (
                          <Spinner animation="border" />
                        ) : (
                          <SaveIcons />
                        )}
                      </Button>}
                      <div className="copy-btn-wrapper">
                          {urlValue && (
                            <CopyToClipboard
                              text={urlValue}
                              onCopy={(e) => handleCopy(e)}
                            >
                              <Button className="outline-btn">
                                <ExportIcon />
                              </Button>
                            </CopyToClipboard>
                          )}

                          <span
                            className={`copied-tooltip ${copied ? "show" : ""}`}
                          >
                            Copied
                          </span>
                        </div>
                    </div>
                    <VerticalDropdown dropdownItems={dropdownItems} />
                  </div>
                </div>

                <div className="rarity-tool-grid">
                  <div className="rarity-tool-left">
                    <GemologicalCharacteristics
                      report={reportData}
                      barColor={color() || "#f1efef"}
                      GraphTextColor={GraphTextColor}
                    />
                  </div>
                  <div className="rarity-tool-right">
                    <DiamondRare report={reportData}  colorCode={color() || "#f1efef"}  qrCodeUrl={qrCodeUrl} />
                  </div>
                </div>

                <div className="report-action-footer ">
                  <div className="report-action-btn action-btn-mob">
                    <Button
                      className="outline-btn"
                      onClick={() => handleCreateNewReport()}
                    >
                      <PlusIcon />
                      New
                    </Button>
                    {isPdf ? <Loading text="Loading" /> : 
                    <Button
                      className="outline-btn pdf-btn"
                      onClick={() => handleDownLoadReport(reportData?.pdfurl)}
                    >
                      {isPdf ? (
                        <Spinner animation="border" />
                      ) : (
                        <>
                          {" "}
                          <DownloadIcon />
                          PDF
                        </>
                      )}
                    </Button>
                    }
                   {isActive ? <Loading text="Saving"/> :
                   <Button
                      disabled={isActive}
                      className="outline-btn"
                      onClick={() => handleSaveReport()}
                    >
                      <SaveIcons />

                      {isActive ? <Spinner animation="border" /> : "Save"}
                    </Button>}
                    

                    <div className="copy-btn-wrapper">
                      {urlValue && (
                        <CopyToClipboard
                          text={urlValue}
                          onCopy={(e) => handleCopy(e)}
                        >
                          <Button className="outline-btn">
                            <ExportIcon />
                          </Button>
                        </CopyToClipboard>
                      )}

                      <span
                        className={`copied-tooltip ${copied ? "show" : ""}`}
                      >
                        Copied
                      </span>
                    </div>
                  </div>

                  <div className="rarity-header-section grade-mob-view">
                    <div className="rarity-header-right">
                      <div className="report-action-btn">
                        <Button
                          className="outline-btn"
                          onClick={() => handleCreateNewReport()}
                        >
                          <PlusIcon />
                        </Button>
                        {isPdf ? <Loading text="Loading" type="mobile"/>:
                        <Button
                          className="outline-btn pdf-btn"
                          onClick={() =>
                            handleDownLoadReport(reportData?.pdfurl)
                          }
                        >
                          {isPdf ? (
                            <Spinner animation="border" />
                          ) : (
                            <>
                              {" "}
                              <DownloadIcon />
                            </>
                          )}
                        </Button>
                        }
                        {isActive ? <Loading text="Saving" type="mobile"/> :
                        <Button
                          disabled={isActive}
                          className="outline-btn"
                          onClick={() => handleSaveReport()}
                        >
                          {isActive ? (
                            <Spinner animation="border" />
                          ) : (
                            <SaveIcons />
                          )}
                        </Button>}

                        <div className="copy-btn-wrapper">
                          {urlValue && (
                            <CopyToClipboard
                              text={urlValue}
                              onCopy={(e) => handleCopy(e)}
                            >
                              <Button className="outline-btn">
                                <ExportIcon />
                              </Button>
                            </CopyToClipboard>
                          )}

                          <span
                            className={`copied-tooltip ${copied ? "show" : ""}`}
                          >
                            Copied
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

               
              </div>
            </div>
          </div>
        </div>
      </Layout>
      <div className="download-pdf-wrapper" ref={ref}>
        <PdfArgyleReportTemplate
          loading={false}
          report={reportData}
          barColor={color()}
          GraphTextColor={GraphTextColor}
        />
      </div>
    </>
  );
};

export default ArgyleReport;

const ExportIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.74707 4.00047H10.2111C10.4011 4.00053 10.584 4.07271 10.7229 4.20244C10.8617 4.33217 10.9461 4.50977 10.9591 4.69935C10.972 4.88893 10.9126 5.07636 10.7926 5.22377C10.6727 5.37117 10.5013 5.46757 10.3131 5.49347L10.2111 5.50047H6.74707C6.17711 5.50038 5.62835 5.71661 5.21164 6.10547C4.79493 6.49434 4.54133 7.02686 4.50207 7.59547L4.49707 7.75047V17.2505C4.49725 17.8204 4.71373 18.3691 5.10278 18.7856C5.49183 19.2021 6.02445 19.4555 6.59307 19.4945L6.74707 19.5005H16.2471C16.8172 19.5005 17.3661 19.2842 17.7828 18.8951C18.1996 18.506 18.453 17.9733 18.4921 17.4045L18.4971 17.2505V16.7525C18.4951 16.5611 18.5664 16.3762 18.6963 16.2357C18.8263 16.0952 19.005 16.0096 19.1959 15.9966C19.3869 15.9835 19.5756 16.044 19.7234 16.1656C19.8712 16.2871 19.967 16.4606 19.9911 16.6505L19.9971 16.7525V17.2505C19.9969 18.2103 19.6287 19.1335 18.9683 19.83C18.3079 20.5265 17.4055 20.9433 16.4471 20.9945L16.2471 21.0005H6.74707C5.78691 21.0005 4.8633 20.6323 4.16656 19.9717C3.46981 19.311 3.05302 18.4083 3.00207 17.4495L2.99707 17.2495V7.74947C2.99724 6.78964 3.36544 5.86642 4.02586 5.16992C4.68627 4.47341 5.58861 4.05666 6.54707 4.00547L6.74707 4.00047ZM14.5001 6.52047V3.75047C14.5 3.61251 14.538 3.47721 14.6098 3.35943C14.6816 3.24166 14.7846 3.14599 14.9073 3.08293C15.03 3.01987 15.1677 2.99188 15.3053 3.00203C15.4428 3.01218 15.575 3.06009 15.6871 3.14047L15.7691 3.20847L21.7631 8.95847C22.0431 9.22747 22.0691 9.65847 21.8401 9.95647L21.7631 10.0415L15.7691 15.7935C15.6695 15.8891 15.5455 15.9553 15.4108 15.985C15.276 16.0147 15.1356 16.0066 15.0051 15.9616C14.8747 15.9166 14.7591 15.8365 14.6713 15.7301C14.5834 15.6237 14.5266 15.4951 14.5071 15.3585L14.5001 15.2515V12.5265L14.1561 12.5565C11.7561 12.8065 9.45607 13.8875 7.24207 15.8165C6.72207 16.2695 5.91907 15.8415 6.00507 15.1585C6.66907 9.83847 9.45107 6.90747 14.2001 6.53947L14.5001 6.52047ZM16.0001 5.50747V7.25047C16.0001 7.44938 15.9211 7.64014 15.7804 7.7808C15.6397 7.92145 15.449 8.00047 15.2501 8.00047C11.3761 8.00047 8.97607 9.67647 7.93807 13.1575L7.85907 13.4355L8.21107 13.1985C10.4501 11.7375 12.7981 11.0005 15.2511 11.0005C15.4325 11.0005 15.6077 11.0663 15.7443 11.1856C15.8809 11.3049 15.9696 11.4697 15.9941 11.6495L16.0011 11.7505V13.4935L20.1601 9.50047L16.0001 5.50747Z"
        fill="#bf8f02"
      />
    </svg>
  );
};



const DownloadIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.156 15.242c.232 0 .447.097.6.25A.9.9 0 0 1 21 16.1v3.991l-.008.115-.02.107a.856.856 0 0 1-.833.687H3.856a.853.853 0 0 1-.845-.76C3 20.187 3 20.142 3 20.085v-3.992c0-.471.385-.852.85-.852a.852.852 0 0 1 .85.852v3.197h14.605v-3.197c0-.471.386-.852.85-.852zM12.01 3c.272 0 .522.114.703.29a.983.983 0 0 1 .29.704v9.215l2.51-2.515a.998.998 0 0 1 1.405 0 1.018 1.018 0 0 1-.017 1.408l-4.177 4.185c-.005.011-.017.017-.022.023a.984.984 0 0 1-.55.278c-.017 0-.034.006-.051.006l-.051.005H12l-.096-.005c-.017 0-.034-.006-.051-.006a.966.966 0 0 1-.55-.278l-.023-.023-4.177-4.185a.994.994 0 0 1-.289-.704c0-.255.097-.51.29-.704a.998.998 0 0 1 1.405 0l2.51 2.515V3.994c0-.545.448-.994.992-.994z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
};

const PlusIcon = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 13H3v-2h8V3h2v8h8v2h-8v8h-2z"
        fill="#bf8f02"
        fillRule="evenodd"
      />
    </svg>
  );
};
